module.exports = __webpack_public_path__ + "static/launch-2bc952bdbe670bcf1b15097b17a45d22.jpg";